<template>
  <div class="technical-review">
    <AccessBlock :id="PROJECT_TECHNICAL_REVIEW_DC_BLOCK">
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-technical-review-dc
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-check-square-o mr-2"></i>{{ $t('project_technical_review_dc') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="project-technical-review-dc" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectTechnicalReviewSide
                v-if="technicalReviewDcProject"
                :blockId="PROJECT_TECHNICAL_REVIEW_DC_BLOCK"
                :project="technicalReviewDcProject"
                side="dc"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>

    <AccessBlock :id="PROJECT_TECHNICAL_REVIEW_AC_BLOCK">
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-technical-review-ac
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-check-square-o mr-2"></i>{{ $t('project_technical_review_ac') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="project-technical-review-ac" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectTechnicalReviewSide
                v-if="technicalReviewAcProject"
                :blockId="PROJECT_TECHNICAL_REVIEW_AC_BLOCK"
                :project="technicalReviewAcProject"
                side="ac"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>

    <AccessBlock v-if="isTimeTrackingSummaryShownToGuest" :id="PROJECT_TIME_TRACKING_SUMMARY_BLOCK">
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-time-tracking-summary
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-clock-o mr-2"></i>{{ $t('timeTrackingSummaryHeading') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="project-time-tracking-summary" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectTimeTrackingSummary
                v-if="timeTrackingSummaryProject"
                :project="timeTrackingSummaryProject"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { yesNoStateReversedColor } from '@/helpers/colors';
import { showToGuest } from '@/helpers/userCapabilities';
import AccessBlock from '@/components/Access/AccessBlock.vue';
import ProjectTechnicalReviewSide from '@/blocks/project/ProjectTechnicalReviewSide.vue';
import ProjectTimeTrackingSummary from '@/blocks/project/ProjectTimeTrackingSummary.vue';
import {
  PROJECT_TECHNICAL_REVIEW_AC_BLOCK,
  PROJECT_TECHNICAL_REVIEW_DC_BLOCK,
  PROJECT_TIME_TRACKING_SUMMARY_BLOCK,
} from '@/navigation/accessNodes';

/** Number of the unsaved project (ProjectEdit `_new`); it has no blocks yet. */
const NEW_PROJECT_NUMBER = '_new';

export default {
  name: 'ItemSelect',
  components: {
    AccessBlock,
    ProjectTechnicalReviewSide,
    ProjectTimeTrackingSummary,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      PROJECT_TECHNICAL_REVIEW_DC_BLOCK,
      PROJECT_TECHNICAL_REVIEW_AC_BLOCK,
      PROJECT_TIME_TRACKING_SUMMARY_BLOCK,
      isAttachmentUploadComplete: false,
      // Guest permissions
      guestVisibleSections: {
        technicalReview: true,
        time_tracking_summary: false,
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isOrganizationRoleNavigationEnabled']),
    /** Block data of project-technical-review-dc; the unsaved project goes to the block itself. */
    technicalReviewDcProject() {
      if (this.project.number === NEW_PROJECT_NUMBER) {
        return this.project;
      }

      return this.project.blocks?.technicalReviewDc ?? null;
    },
    /** Block data of project-technical-review-ac; the unsaved project goes to the block itself. */
    technicalReviewAcProject() {
      if (this.project.number === NEW_PROJECT_NUMBER) {
        return this.project;
      }

      return this.project.blocks?.technicalReviewAc ?? null;
    },
    /** Block data of project-time-tracking-summary; the unsaved project goes to the block itself. */
    timeTrackingSummaryProject() {
      if (this.project.number === NEW_PROJECT_NUMBER) {
        return this.project;
      }

      return this.project.blocks?.timeTrackingSummary ?? null;
    },
    /** The guest rule applies in Legacy-Authz only; in Matrix-Authz the level decides. */
    isTimeTrackingSummaryShownToGuest() {
      return (
        this.isOrganizationRoleNavigationEnabled ||
        showToGuest('time_tracking_summary', this.guestVisibleSections)
      );
    },
    preferredDeliveryInVlinkAt: {
      get() {
        return this.$calendarFormat(this.project.technicalReview.preferredDeliveryInVlinkAt);
      },
      set(value) {
        this.project.technicalReview.preferredDeliveryInVlinkAt = value;
      },
    },
    additionalOrdersDispatchedAt: {
      get() {
        return this.$calendarFormat(this.project.technicalReview.additionalOrdersDispatchedAt);
      },
      set(value) {
        this.project.technicalReview.additionalOrdersDispatchedAt = value;
      },
    },
  },
  methods: {
    ...mapActions([]),
    yesNoStateReversedColor,
  },
  async mounted() {},
};
</script>
